/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetTourResponse } from '../../models/get-tour-response';
import { KeyType } from '../../models/key-type';

export interface GetTour$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The tour key
 */
  tourKey: KeyType;
}

export function getTour(http: HttpClient, rootUrl: string, params: GetTour$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTourResponse>> {
  const rb = new RequestBuilder(rootUrl, getTour.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('tourKey', params.tourKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetTourResponse>;
    })
  );
}

getTour.PATH = '/organization-sites/{organizationSiteKey}/carrier/tours/{tourKey}';
